import { L as d } from "./reactive-element-BDpydG15-BOs0_4cf.js";
import { html as g } from "./index-BqflxSah.js";
import "./lit-element-DC8UPTKS-4MAMRHpW.js";
import { property as n } from "./index-Ba2D8NOp.js";
import { d as p } from "./abstract-base-DlmRC3qm-BIlD7-mG.js";
import { t as b } from "./beacon-primitive-ChVMWFlW-Df2Js5lw.js";
const v = d`:host{--icon: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='8' fill='%23DD3636'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 3.75C7.72386 3.75 7.5 3.97386 7.5 4.25V9.25C7.5 9.52614 7.72386 9.75 8 9.75C8.27614 9.75 8.5 9.52614 8.5 9.25V4.25C8.5 3.97386 8.27614 3.75 8 3.75ZM8 12.25C8.41421 12.25 8.75 11.9142 8.75 11.5C8.75 11.0858 8.41421 10.75 8 10.75C7.58579 10.75 7.25 11.0858 7.25 11.5C7.25 11.9142 7.58579 12.25 8 12.25Z' fill='white'/%3E%3C/svg%3E%0A");margin-block-end:var(--beacon-unit-subatomic);padding-block-start:var(--beacon-unit-subatomic)}:host([is-valid]){--icon: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='8' fill='%23248647'/%3E%3Cpath d='M5 8.71605L6.99561 10.5833L10.4167 6' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")}.text{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default));align-items:center;color:var(--beacon-color-text-important);display:flex}.text:before{block-size:calc(1.25 * var(--beacon-unit-base));content:"";inline-size:calc(1.25 * var(--beacon-unit-base));margin-inline-end:calc(.625 * var(--beacon-unit-base));min-inline-size:calc(1.25 * var(--beacon-unit-base));background-image:var(--icon);background-position:center;background-repeat:no-repeat}`;
var u = Object.defineProperty, s = (t, o, i, f) => {
  for (var e = void 0, a = t.length - 1, r; a >= 0; a--)
    (r = t[a]) && (e = r(o, i, e) || e);
  return e && u(o, i, e), e;
};
const c = "beacon-error", l = class extends b(p) {
  constructor() {
    super(...arguments), this.beaconTagName = c, this.isValid = !1, this.message = "";
  }
  static get styles() {
    return [super.styles, v];
  }
  render() {
    return g`<span class="text ${this.isValid ? "valid" : "error"}">${this.message}</span>`;
  }
};
l.tagName = c;
let m = l;
s([
  n({ attribute: "is-valid", type: Boolean, reflect: !0 })
], m.prototype, "isValid");
s([
  n()
], m.prototype, "message");
export {
  m as BeaconError
};
